// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__t5Cbr","layout":"styles_layout__0EWmn","text":"styles_text__qo3R7","title":"styles_title__5WrYk"};